<template>
  <div class="auth-page font-jumper">
    <section class="auth-visual" :class="{ 'auth-visual-dimmed': dimmed }">
      <div
        class="auth-visual-image"
        :style="{ backgroundImage: `url(${backgroundImage})` }"
      ></div>
      <div class="auth-visual-overlay"></div>
      <div v-if="$slots.steps" class="auth-steps">
        <slot name="steps"></slot>
      </div>
    </section>

    <main class="auth-content">
      <div class="auth-card">
        <h1 class="auth-title font-jumperbold" v-html="title"></h1>

        <img class="auth-logo" :src="logoImage" alt="Acounto" />

        <nav v-if="showTabs" class="auth-tabs" aria-label="Auth navigation">
          <router-link
            class="auth-tab"
            :class="{ active: activeTab === 'register' }"
            to="/start"
          >
            Regisztráció
          </router-link>
          <router-link
            class="auth-tab"
            :class="{ active: activeTab === 'login' }"
            to="/login"
          >
            Bejelentkezés
          </router-link>
        </nav>

        <slot></slot>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "AuthLayout",
  props: {
    activeTab: {
      type: String,
      default: "login",
    },
    title: {
      type: String,
      required: true,
    },
    dimmed: {
      type: Boolean,
      default: false,
    },
    showTabs: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    backgroundImage() {
      return require("@/assets/img/loginbg.webp");
    },
    logoImage() {
      return require("@/assets/img/Acounto_logo.svg");
    },
  },
};
</script>

<style scoped lang="scss">
.auth-page {
  box-sizing: border-box;
  width: 100%;
  max-width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: grid;
  grid-template-columns: minmax(480px, 1.2fr) minmax(420px, 0.8fr);
  gap: clamp(28px, 3.3vw, 64px);
  padding: clamp(22px, 2.5vw, 48px) clamp(28px, 2.9vw, 56px);
  background: linear-gradient(180deg, #ffffff 0%, #eff3f4 100%);
  color: #000;
}

.auth-visual {
  position: relative;
  height: 100%;
  overflow: hidden;
  border-radius: 72px;
}

.auth-visual-image,
.auth-visual-overlay {
  position: absolute;
  inset: 0;
}

.auth-visual-image {
  background-position: center;
  background-size: cover;
}

.auth-visual-dimmed .auth-visual-overlay {
  background: rgba(37, 39, 52, 0.7);
}

.auth-steps {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.auth-content {
  align-self: start;
  width: 100%;
  margin-top: 14px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.auth-card {
  width: min(100%, 760px);
  max-height: 100%;
}

.auth-title {
  max-width: 720px;
  margin: 0 auto clamp(30px, 4vh, 58px);
  font-size: 26px;
  line-height: 0.9;
  letter-spacing: -0.04em;
  text-align: center;
}

.auth-logo {
  display: none;
  width: clamp(132px, 12vw, 188px);
  height: auto;
  margin: 0 auto 24px;
}

.auth-tabs {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  width: 100%;
  height: 40px;
  margin-bottom: clamp(36px, 6vh, 72px);
  padding: 4px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #aebfc7;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.45);
}

.auth-tab,
#app .auth-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  border-radius: 999px;
  color: #000 !important;
  font-family: JumperThin, sans-serif !important;
  font-size: 16px;
  line-height: 1;
  text-decoration: none !important;
  transition: background 0.2s ease;
}

.auth-tab.active,
#app .auth-tab.active {
  background: #b2ec5d !important;
}

@media (max-width: 1200px) {
  .auth-page {
    grid-template-columns: 1fr;
    gap: 32px;
    padding: 16px;
  }

  .auth-visual {
    height: 260px;
    min-height: 260px;
    border-radius: 48px;
  }

  .auth-content {
    min-height: auto;
    height: auto;
  }

  .auth-title {
    margin-bottom: 30px;
  }

  .auth-tabs {
    margin-bottom: 36px;
  }
}

@media (max-width: 576px) {
  .auth-page {
    width: 100vw;
    max-width: 100vw;
    padding: 16px;
    overflow: hidden;
  }

  .auth-visual {
    display: none;
  }

  .auth-content,
  .auth-card {
    min-width: 0;
    overflow-x: visible;
  }

  .auth-title {
    display: none;
  }

  .auth-logo {
    display: block;
    width: 142px;
    margin-bottom: 22px;
  }

  .auth-tabs {
    max-width: 100%;
  }

  .auth-tab,
  #app .auth-tab {
    min-width: 0;
    font-size: 16px;
  }
}
</style>
